export const WIRESTOCK_MARKETPLACE_AGENCY_NAME = 'wirestock_marketplace';
